import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { useLanguage } from '../components/LanguageContext';

const PrivacyPolicy = () => {
  const { language, translations } = useLanguage();
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const privacyPolicy = translations['privacyPolicyTranslations.json']?.privacy_policy || {};
  const title = privacyPolicy.title?.[language] || 'Privacy Policy';
  const content = privacyPolicy.content?.[language] || '';

  const renderTextWithStyles = (text) => {
    if (!text) return null;
    const keywords = ['Education', 'Experience', 'Languages', 'Location'];
    return text.split('\n').map((line, index, array) => {
      const parts = line.split(new RegExp(`(${keywords.join('|')})`, 'g')).map((part, i) => {
        if (keywords.includes(part)) {
          return <span key={i} style={{ fontWeight: 700 }}>{part}</span>;
        }
        return part;
      });
      return (
        <React.Fragment key={index}>
          {parts}
          {index < array.length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="content_container">
      <Nav />
      <div className="container">
        <div className="privacy_policy">
          <h1>{title}</h1>
          <p>{renderTextWithStyles(content)}</p>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default PrivacyPolicy;